import ApiGo_AuditTrail from "./ApiGo_AuditTrail";

// ⌬ 測試 i18n - withTranslation (HOC)
import i18n from './../i18n'; // useTranslation 一般function class 無法使用改狦原生寫。
import Account from "./Account";
// import { loginStore } from "../comm_stores";
// import { SET_LOGIN_STATUS } from "../stores/reducer_loginStatus";

// export let status;
let status;

// Step 1: You create an AbortController(For now I just used this)
const apiController = new AbortController();

// Step 2: You get the AbortControllers signal like this:
const signal = apiController.signal;

// Step 3: You pass the signal to fetch like so:
// Watch signal: signal, // <------ This is our AbortSignal

// Step 4: Just abort whenever you need to:
// apiController.abort();
const abort = apiController.abort;
/**
 * Api 共用格式 body
 *
 * @param {Object} Api - Api 共用格式 body參數
 * - Api.url api連結
 * - Api.method http 協定
 * - Api.header 格式
 * - Api.data 傳送到伺服器資料
 * - Api.type api 函式名稱(python def 名稱)
 * - Api.element(實驗階段) 針對元素做個別操作
 * @param {string} Api.url api連結
 * @param {string} Api.method http 協定
 * @param {string} Api.header 格式
 * @param {string} Api.data 傳送到伺服器資料
 * @param {string} Api.type api 函式名稱(python def 名稱)
 * @param {string} Api.msg 打包 改變data值 的訊息
 * @param {string} Api.element(實驗階段) 針對元素做個別操作
 *
 * @param {string} option(實驗階段) 其它設定
 */
export default ({ url, method, headers, data, type, audit_trial_excluded = false, msg = "", element = "" }, option = {}) => {
    return fetch(url, { // url 請求位置
        method: method || 'GET', //請求方法
        // 發送給伺服器的資料
        body: data ? JSON.stringify(data) : null,
        // body: data || null,
        headers: headers || {
            'content-type': 'application/json',
            ...new Account().getLocakToken()
        },
        signal: signal, // <------ Step 3: This is our AbortSignal
        // mode: 'cors', // 跨域處理
        // ...option // 其他配置
    }).then(async res => {
        status = res.status;
        // NOTE: 寫入歷史記錄
        if (method !== null && method !== undefined) {

            if (
                method === "PUT" ||
                method === "POST" ||
                method === "DELETE" ||
                method === "PATCH"
                // || method === "GET" // for 測試用 實際上 GET 不需要記錄
            ) {
                // ⌬ 1.2 React-i18next
                // const t = i18n.t;

                const audit_trail_event = "AUDIT_TRAIL.EVENTS." + type.toUpperCase();
                // if (String(res.status)[0] === "2") { // 把http status 2開頭都寫入成功
                if (res.status === 200 || res.status === 201 || res.status === 202 || res.status === 204) {
                    const action = i18n.t(audit_trail_event, { lng: "zh-TW" }) +
                        (msg ? (" " + msg + " ") : " ") +
                        // i18n.t('GLOBAL.STATUS.SUCCESS', { lng: "ja-JP" });
                        i18n.t('GLOBAL.STATUS.SUCCESS', { lng: "zh-TW" });
                    // audit trial excluded == false 則不記錄到 audit trail !!! (不然 verify user太多了)
                    if (!audit_trial_excluded) { ApiGo_AuditTrail.postAuditTrail(action, type); }
                } else {
                    const action = i18n.t(audit_trail_event, { lng: "zh-TW" }) +
                        (msg ? (" " + msg + " ") : " ") +
                        // i18n.t('GLOBAL.STATUS.FAILURE', { lng: "ja-JP" });
                        i18n.t('GLOBAL.STATUS.FAILURE', { lng: "zh-TW" });

                    ApiGo_AuditTrail.postAuditTrail(action, type);
                }

            }
        }
        if (status === 200 || status === 201 || status === 202 || status === 204) {
            if (res.statusText === "No Content") { return "success" }
            return res.json()
        } else {
            // 報錯 回傳陣列 狀態碼, 狀態訊息
            // if(status===401){
            //     loginStore.dispatch(SET_LOGIN_STATUS({
            //         status:'denied',
            //         responseState:401
            //     }))
            // }
            let response = null;

            try {
                response = await res.json();
            } catch {
                // 某些錯誤回應沒有 JSON body
            }

            throw {
                status: res.status,
                statusText: res.statusText,
                response,
            };
        }

    })
        .catch(res => { throw res })
}

export { status, abort, apiController };